import Sidebar from "../components/Sidebar"
import React, { useState, useEffect, useCallback } from "react"

import { useNavigate } from "react-router-dom"
import { APP_ROUTES } from "../utils/constants"
import getTimeDiffInDays from "../utils/getTimeDiffInDays"
import getTimeDiffFaString from "../utils/getTimeDiffFaString"
import Table from "../components/Table"
import actionHelper from "../lib/actionHelper"

import { toast } from "react-toastify"
import { useAuth } from "../lib/useAuth"
import { useSocket, useSocketEvent } from "../contexts/SocketContext"
import CreateBannerBotModal from "../components/BannerBots/CreateBannerBotModal"
import LogsModal from "../components/LogsModal"
import BannerBotMoreModal from "../components/BannerBots/BannerBotMoreModal"
import AutoRenewButton from "../components/BannerBots/AutoRenewButton"
import sidebarStore from "../store/sidebarStore"

const cols = [
    {
        name: "حالت",
        colSpan: 1,
    },
    {
        name: "وضعیت",
        colSpan: 1,
    },
    {
        name: "اسم بات",
        colSpan: 1,
    },
    {
        name: "سرور",
        colSpan: 1,
    },
    {
        name: "پورت کوئری",
        colSpan: 1,
    },
    {
        name: "تاریخ انقضا",
        colSpan: 1,
    },
    {
        name: "تمدید اتومات",
        colSpan: 1,
    },
    {
        name: "تنظیمات",
        colSpan: 1,
    },
]

const BannerBots = () => {
    const { user, loading } = useAuth()
    const { isConnected, sendMessage } = useSocket()
    const [botList, setBotList] = useState([])
    const navigate = useNavigate()
    const [rows, setRows] = useState([])
    const [createIsOpen, setCreateIsOpen] = useState(false)
    const [selecteds, setSelecteds] = useState([])
    const [searchBar, setSearchBar] = useState("")
    const [createPrice, setCreatePrice] = useState(0)
    const setSection = sidebarStore((state) => state.setSection)

    const searchBarChangeHandler = async (e) => {
        await new Promise((resolve) => setTimeout(resolve, 500))
        setSearchBar(e.target.value)
    }

    const toggleCreate = () => {
        setCreateIsOpen(!createIsOpen)
    }

    const createRows = (bots) => {
        return bots?.map((bot) => {
            const now = new Date()
            const createdDate = new Date(bot.created)
            const expireDate = new Date(bot.expires)
            const expires = bot.expires == null ? null : getTimeDiffInDays(expireDate, now)
            bot.expString = bot.expires == null ? null : getTimeDiffFaString(expireDate, now)
            bot.crtString = getTimeDiffFaString(createdDate, now)

            let obj = {
                id: bot.id,
                state: (
                    <span className={bot.state == "active" ? "bg-blur-success" : "bg-blur-warning"}>
                        {bot.state == "active" ? "فعال" : "غیرفعال"}
                    </span>
                ),
                status: (
                    <span className={bot.status == "online" ? "bg-blur-success" : "bg-blur-danger"}>
                        {bot.status == "online" ? "روشن" : "خاموش"}
                    </span>
                ),
                templateName: bot.templateName,
                server: bot.conn.host,
                queryPort: bot.conn.queryPort,
                expString:
                    expires !== null ? (
                        <span className={expires >= 0 ? "text-success" : "text-danger"}>{bot.expString}</span>
                    ) : (
                        <span>دائمی</span>
                    ),
                renew: <AutoRenewButton user={user} bot={bot} />,
                more: (
                    <div className="flex gap-2">
                        <BannerBotMoreModal bot={bot} user={user} />
                        <LogsModal service={{ en: "bannerBot", fa: "بات بنر داینامیک" }} id={bot.id} />
                    </div>
                ),
            }
            return obj
        })
    }

    const handleGetPrice = useCallback((price) => {
        setCreatePrice(price)
    }, [])

    const handleBotList = useCallback((botList) => {
        setBotList(botList)
    }, [])

    const handleBotAdded = useCallback((newBot) => {
        setBotList((botList) => [...botList, newBot])
    }, [])

    const handleBotUpdated = useCallback((newData) => {
        setBotList((oldBots) => {
            return oldBots.map((s) => {
                return s.id == newData.id ? Object.assign(s, newData) : s
            })
        })
    }, [])
    const handleStatusUpdated = useCallback((payload) => {
        const { templateName, status } = payload

        setBotList((oldBots) => {
            return oldBots.map((bot) => (bot.templateName == templateName ? { ...bot, status } : bot))
        })
    }, [])

    const handleBotDeleted = useCallback((deletedId) => {
        setBotList((oldBots) => {
            return oldBots.filter((s) => s.id != deletedId)
        })
    }, [])

    // Use the stable callbacks with socket events'
    useSocketEvent("bannerBotCreatePrice", handleGetPrice)
    useSocketEvent("bannerBotList", handleBotList)
    useSocketEvent("bannerBotAdded", handleBotAdded)
    useSocketEvent("bannerBotUpdated", handleBotUpdated)
    useSocketEvent("bannerBotDeleted", handleBotDeleted)
    useSocketEvent("bannerbot-status-updated", handleStatusUpdated)

    const multiTasking = {
        setSelecteds: setSelecteds,
        selecteds: selecteds,
        tasks: [
            {
                title: "روشن کردن",
                color: "success",
                icon: "play",
                onClick: () => {
                    if (selecteds.length != 0) {
                        actionHelper({
                            confirmation: {
                                label: "ایا مطمئن هستید بات های انتخاب شده را روشن کنید؟",
                                actionLabel: "روشن کردن",
                                color: "success",
                            },
                            callback: () => {
                                // return startAllbannerBots(selecteds.map((s) => s.id))
                            },
                            texts: { success: "استارت شد", pending: "درحال استارت" },
                        })
                    } else {
                        toast.error("باتی انتخاب نشده است")
                    }
                },
            },
            {
                title: "خاموش کردن",
                color: "danger",
                icon: "power-off",
                onClick: () => {
                    if (selecteds.length != 0) {
                        actionHelper({
                            confirmation: {
                                label: "آیا مطمئن هستید بات های انتخاب شده را خاموش کنید؟",
                                actionLabel: "خاموش کردن",
                                color: "danger",
                            },
                            callback: () => {
                                // return stopAllbannerBots(selecteds.map((s) => s.id))
                            },
                            texts: { success: "خاموش شد", pending: "درحال خاموش" },
                        })
                    } else {
                        toast.error("باتی انتخاب نشده است")
                    }
                },
            },
            {
                title: "ریستارت کردن",
                color: "border",
                icon: "repeat",
                onClick: () => {
                    if (selecteds.length != 0) {
                        actionHelper({
                            confirmation: {
                                label: "ایا مطمئن هستید بات های انتخاب شده را ریستارت کنید؟",
                                actionLabel: "ریستارت کردن",
                                color: "danger",
                            },
                            callback: () => {
                                // return restartAllbannerBots(selecteds.map((s) => s.id))
                            },
                            texts: { success: "ریستارت شد", pending: "درحال ریستارت" },
                        })
                    } else {
                        toast.error("باتی انتخاب نشده است")
                    }
                },
            },
        ],
    }

    const section = {
        title: "بات های مدیریتی",
        setSearchBar: searchBarChangeHandler,
        buttons: [
            {
                name: "ساخت بات جدید",
                onClick: toggleCreate,
                color: "border",
                iconName: "square-plus",
            },
            {
                name: "روشن کردن همه",
                onClick: () =>
                    actionHelper({
                        confirmation: {
                            label: "ایا مطمئن هستید همه ی بات ها را روشن کنید؟",
                            actionLabel: "روشن کردن",
                            color: "success",
                        },
                        callback: () => {
                            // return startAllbannerBots()
                        },
                        texts: { success: "روشن شد", pending: "درحال روشن کردن" },
                    }),
                color: "success",
                iconName: "play",
            },
            {
                name: "ریستارت همه",
                onClick: () =>
                    actionHelper({
                        confirmation: {
                            label: "ایا مطمئن هستید همه ی بات ها را ریستارت کنید؟",
                            actionLabel: "ریستارت کردن",
                            color: "warning",
                        },
                        callback: () => {
                            // return restartAllbannerBots()
                        },
                        texts: { success: "ریستارت شد", pending: "درحال ریستارت" },
                    }),
                color: "warning",
                iconName: "repeat",
            },
            {
                name: "خاموش کردن همه",
                onClick: () =>
                    actionHelper({
                        confirmation: {
                            label: "ایا مطمئن هستید همه ی بات ها را خاموش کنید؟",
                            actionLabel: "خاموش کردن",
                            color: "danger",
                        },
                        callback: () => {
                            // return stopAllbannerBots()
                        },
                        texts: { success: "خاموش شد", pending: "درحال خاموش" },
                    }),
                color: "danger",
                iconName: "power-off",
            },
        ],
    }

    const handleRefresh = () => {
        sendMessage("getBannerBotList")
    }

    useEffect(() => {
        if (loading && !isConnected) {
            return
        }

        if (user && user.can_use_banner) {
            sendMessage("getBannerBotList")
            sendMessage("bannerBotGetCreatePrice")
        } else if (user && user.can_use_bot) {
            navigate(APP_ROUTES.MUSIC_BOTS)
        } else if (user && user.can_use_servers) {
            navigate(APP_ROUTES.INDEX)
        } else if (user) {
            toast.error("شما هیچگونه دسترسی ندارید")
            localStorage.clear()
            navigate(APP_ROUTES.SIGN_IN)
        } else {
            return
        }
    }, [loading, isConnected])

    useEffect(() => {
        if (searchBar && searchBar !== "" && botList) {
            let searchedRows = botList.filter((bot) => {
                if (
                    !bot?.conn?.botName.toString().includes(searchBar) &&
                    !bot?.author?.toString().includes(searchBar) &&
                    !bot?.template_name?.toString().includes(searchBar) &&
                    !bot?.conn?.queryPort?.toString().includes(searchBar) &&
                    !bot?.conn?.serverPort?.toString().includes(searchBar)
                ) {
                    return false
                } else {
                    return true
                }
            })
            setRows(createRows(searchedRows))
        } else if (botList) {
            setRows(createRows(botList))
        }
    }, [searchBar, botList])

    if (!user) {
        return "Loading..."
    }
    setSection(section)

    return (
        <>
            <CreateBannerBotModal isOpen={createIsOpen} toggleModal={toggleCreate} price={createPrice} />
            <Table
                cols={cols}
                rows={rows}
                pagin={{ maxRows: 10 }}
                multiTasking={multiTasking}
                handleRefresh={handleRefresh}
            />
        </>
    )
}

export default BannerBots
